const moment = require('moment');
export function openToday() {
  const url = '/wordpress/wp-content/todaystatus.json';
  const lang = $(document.body).data('lang');
  const nowAPI = moment().format('YYYY-MM-DD');
  $.getJSON(url, function(data) {
    let message = '';
    let openstatus = '';
    if (data['items'].length > 0) {
      const item = data['items'][0];
      if (item.summary === "x" && nowAPI === item.start.date) {
        openstatus = false;
      } else {
        openstatus = true;
      }
    } else {
      openstatus = true;
    }
    moment.locale('ja', { weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'] });
    $('.information-open-today-element').each(function(){
      const $this = $(this);
      let now = '';
      if (lang === 'ja') {
        moment.locale('ja');
        now = moment().format('M月D日(ddd)');
      } else {
        moment.locale('en');
        now = moment().format('MMM Do');
      }
      if (openstatus === true) {
        message = $(document.body).data('open-message');
        $this.addClass('is-positive');
      } else {
        message = $(document.body).data('close-message');
        $this.addClass('is-negative');
      }
      $this.html(now + ' ' + message);
    });
  });
}